import { z } from "zod"

export const powurOSInverterDataSchema = z
  .object({
    id: z.number().int(),
    maxInputDcPower: z.nullable(z.number()),
    isBatteryCompatible: z.nullable(z.boolean()),
    isBattery: z.nullable(z.boolean()).optional(),
    minimumPVOperatingDCInputVoltage: z.nullable(z.number()).optional(),
    maximumPVOperatingDCInputVoltage: z.nullable(z.number()).optional(),
    maximumSolarInputOnGridWatts: z.nullable(z.number()).optional(),
    isStringInverter: z.nullable(z.boolean()).optional(),
    maximumNumberOfStrings: z.nullable(z.number().optional()),
    qty: z.number().default(1),
  })
  .nullable()
export type PowurOsInverterData = z.infer<typeof powurOSInverterDataSchema>
